module.exports = __webpack_public_path__ + "media/cunuc.8b98dfbd.mp4";